export default "__VITE_ASSET__047e79b8__"